import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/auth.store';
import { Spinner } from '@/shared/ui/Spinner';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const status = useAuth((s) => s.status);
  const loadMe = useAuth((s) => s.loadMe);
  const location = useLocation();

  useEffect(() => {
    if (status === 'loading') void loadMe();
  }, [status, loadMe]);

  // Sitzung serverseitig abgelaufen -> zurueck zum Login.
  useEffect(() => {
    const handler = () => useAuth.setState({ user: null, status: 'anonymous' });
    window.addEventListener('pf:session-expired', handler);
    return () => window.removeEventListener('pf:session-expired', handler);
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/anmelden" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
